<template>
  <div ref="slider" class="slider d-flex" :class="{'col-12': !hasPrev}">
    <div v-if="hasPrev" class="text-primary text-center slider-arrow" @click.prevent="prev">
      <fa icon="chevron-circle-left" size="lg" />
    </div>

    <slider-canvas :from="from" :to="to" :item-class="itemClass">
      <slot />
    </slider-canvas>

    <div v-if="hasNext" class="text-primary text-center slider-arrow" @click.prevent="next">
      <fa icon="chevron-circle-right" size="lg" />
    </div>
  </div>
</template>

<script type="application/javascript">
import SliderCanvas from './SliderCanvas.vue'

export default {
  name: 'Slider',
  components: {
    SliderCanvas
  },
  props: {
    initPage: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 6
    },
    itemClass: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      page: this.initPage
    }
  },
  computed: {
    optionCount () {
      return (this.$slots.default || []).length
    },
    pageMax () {
      const itemCount = (this.$slots.default || []).length
      const totalPage = Math.max(0, Math.ceil(itemCount / this.perPage))
      return totalPage
    },
    from () {
      return this.to - this.perPage
    },
    to () {
      return this.page * this.perPage
    },
    classObject () {
      const length = 6
      return {
        'col-2': length === 6,
        'col-3': length <= 3
      }
    },
    hasPrev () {
      if (this.pageMax === this.optionCount) {
        return true
      } else if (this.pageMax === 1) {
        return false
      } else {
        return true
      }
    },
    hasNext () {
      if (this.optionCount > 6) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    prev () {
      if (this.page === 1) {
        this.page = this.pageMax
      } else {
        this.page = Math.max(0, this.page - 1)
      }
    },
    next () {
      if (this.pageMax === this.page) {
        this.page = 1
      } else {
        this.page = Math.min(this.page + 1, this.pageMax)
      }
    },
    initTouch () {
      let touchstartX = 0
      let touchendX = 0
      this.$refs.slider.addEventListener('touchstart', (event) => {
        touchstartX = event.changedTouches[0].screenX
      }, false)
      this.$refs.slider.addEventListener('touchend', (event) => {
        touchendX = event.changedTouches[0].screenX
        if (touchendX < touchstartX) {
          this.prev()
        }
        if (touchendX > touchstartX) {
          this.next()
        }
      }, false)
    }
  }
}
</script>
<style>
.slider-arrow {
  padding: 10px;
}
</style>
